import { searchConfig, dictionaryConfig } from "./typesense-server-config";
import { SearchClient as TypesenseSearchClient } from "typesense";

let INDEX_NAME;
let sortBy;

export async function getIndexSize(serverType = "default") {
  // Select the appropriate server configuration based on the serverType
  let TYPESENSE_SERVER_CONFIG;
  if (serverType === "dictionary") {
    TYPESENSE_SERVER_CONFIG = dictionaryConfig;
    INDEX_NAME = import.meta.env.VITE_DICTIONARY_TYPESENSE_COLLECTION_NAME;
    sortBy = "created_at:asc";
  } else {
    TYPESENSE_SERVER_CONFIG = searchConfig;
    INDEX_NAME = import.meta.env.VITE_TYPESENSE_COLLECTION_NAME;
    sortBy = "date:desc";
  }

  // Initialize Typesense client with the selected server config
  const typesenseSearchClient = new TypesenseSearchClient(
    TYPESENSE_SERVER_CONFIG
  );

  // Perform the search to get index size
  const results = await typesenseSearchClient
    .collections(INDEX_NAME)
    .documents()
    .search({ q: "*", sort_by: sortBy });

  return results["found"];
}

function createSearchClient(serverType = "default") {
  const TYPESENSE_SERVER_CONFIG =
    serverType === "dictionary" ? dictionaryConfig : searchConfig;

  return new TypesenseSearchClient(TYPESENSE_SERVER_CONFIG);
}

function escapeFilterValue(value) {
  return `\`${String(value).replace(/`/g, "\\`")}\``;
}

export async function getCaseByStandardCaseNumber(standardCaseNumber) {
  const caseNumber = String(standardCaseNumber || "").trim();

  if (!caseNumber) {
    return null;
  }

  const typesenseSearchClient = createSearchClient();
  const collection = typesenseSearchClient.collections(
    import.meta.env.VITE_TYPESENSE_COLLECTION_NAME
  );

  const exactMatchResults = await collection.documents().search({
    q: caseNumber,
    query_by: "standard_casenumber",
    filter_by: `standard_casenumber:=${escapeFilterValue(caseNumber)}`,
    infix: "always",
    per_page: 1,
  });

  if (exactMatchResults.hits?.length) {
    return exactMatchResults.hits[0].document;
  }

  const fallbackResults = await collection.documents().search({
    q: caseNumber,
    query_by: "standard_casenumber",
    infix: "always",
    per_page: 10,
  });

  const exactHit = fallbackResults.hits?.find((hit) => {
    const caseNumbers = Array.isArray(hit.document.standard_casenumber)
      ? hit.document.standard_casenumber
      : [hit.document.standard_casenumber];

    return caseNumbers.some(
      (value) =>
        typeof value === "string" &&
        value.trim().toLowerCase() === caseNumber.toLowerCase()
    );
  });

  return exactHit?.document || fallbackResults.hits?.[0]?.document || null;
}
